import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export type UserTier = 'free' | 'paid' | 'loading';

export function useUserTier(): { tier: UserTier; isPaid: boolean; isFree: boolean } {
  const [tier, setTier] = useState<UserTier>('loading');

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user) { setTier('free'); return; }

      supabase
        .from('profiles')
        .select('subscription_tier, unlimited_access')
        .eq('id', user.id)
        .maybeSingle()
        .then(({ data }) => {
          if (!data) { setTier('free'); return; }
          const isPaid =
            data.unlimited_access ||
            data.subscription_tier === 'monthly' ||
            data.subscription_tier === 'annual';
          setTier(isPaid ? 'paid' : 'free');
        });
    });
  }, []);

  return { tier, isPaid: tier === 'paid', isFree: tier === 'free' };
}
